import React from 'react';
import PropTypes from 'prop-types';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import MetaControl from 'Components/UI/Meta/MetaControl';
import {
  FDAccordion, FDAccordionDetails,
  FDAccordionGroup, FDAccordionTitle, FDBodyText, FDHeadlineText, FDStack,
} from '@facet-wealth/design';
import { Richtext } from 'Packages/FacetDesign/Components/Richtext';
import { dataAttrs } from 'Helpers/Testing';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => FDHeadlineText,
    _customProps: {
      color: 'textSecondary',
    },
  }, overrideReadOnly)
  .nameOverride(['question', 'answer'], {
    _component: () => FDBodyText,
  }, overrideReadOnly)
  .override({ name: 'question', hint: 'richtext' }, {
    _component: () => Richtext,
    _customProps: { Component: FDBodyText },
  }, overrideReadOnly)
  .override({ name: 'answer', hint: 'richtext' }, {
    _component: () => Richtext,
    _customProps: { Component: FDBodyText },
  }, overrideReadOnly);


export const EstatePlanningManagementPageFAQ = ({ collection }) => {
  if (collection.resources().length() === 0) {
    return null;
  }

  const [faqResource] = collection;
  return (
    <FDStack direction={'column'} spacing={3} {...dataAttrs('management-page-faq')}>
      <MetaControl resource={faqResource} attrName={'title'} metaOverrideSet={metaOverrideSet} />
      <FDAccordionGroup mutualExclusion>
        {faqResource.attr('questions').resources().list().map((questionResource) => {
          return (
            <FDAccordion
              expansionID={questionResource.id()}
              key={questionResource.id()}
            >
              <FDAccordionTitle>
                <MetaControl resource={questionResource} attrName={'question'} metaOverrideSet={metaOverrideSet} />
              </FDAccordionTitle>
              <FDAccordionDetails>
                <MetaControl resource={questionResource} attrName={'answer'} metaOverrideSet={metaOverrideSet} />
              </FDAccordionDetails>
            </FDAccordion>
          );
        })}
      </FDAccordionGroup>
    </FDStack>
  );
};

EstatePlanningManagementPageFAQ.propTypes = {
  collection: PropTypes.object.isRequired,
};
